export default function CTASection() {
  return (
    <section className="relative overflow-hidden bg-brand-dark">
      {/* Top border */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-brand-gold/40 to-transparent" />

      <div className="relative max-w-5xl mx-auto px-8 py-28 text-center">
        {/* Eyebrow */}
        <div className="flex items-center justify-center gap-3 mb-7">
          <div className="w-6 h-px bg-brand-gold/60" />
          <span className="font-inter text-xs font-medium text-brand-gold uppercase tracking-[0.18em]">
            Dê o primeiro passo
          </span>
          <div className="w-6 h-px bg-brand-gold/60" />
        </div>

        <h2 className="font-cormorant text-4xl lg:text-5xl xl:text-6xl font-semibold text-white leading-tight mb-5">
          Cansado de esperar resposta
          <br />
          <span className="italic text-brand-gold-pale">do INSS sem resultado?</span>
        </h2>

        <p className="font-inter text-sm text-white/70 leading-relaxed max-w-lg mx-auto mb-10">
          Fale agora com uma advogada previdenciária especializada e descubra o que pode ser feito no seu caso.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <a
            href="https://api.whatsapp.com/send?phone=5551996057679&text=Ol%C3%A1,%20vim%20do%20seu%20site%20e%20gostaria%20de%20falar%20com%20um%20advogado."
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-brand-gold hover:bg-brand-gold-light text-white font-inter font-semibold text-sm px-8 py-3.5 rounded-md transition-all duration-200"
          >
            <i className="ri-whatsapp-line text-base" />
            Falar com advogada agora
          </a>

          <a
            href="tel:5551996057679"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 border border-white/25 hover:border-brand-gold hover:text-brand-gold text-white/70 font-inter font-medium text-sm px-8 py-3.5 rounded-md transition-all duration-200"
          >
            <i className="ri-phone-line text-base" />
            (51) 99605-7679
          </a>
        </div>

        <p className="font-inter text-xs text-white/40">
          Atendimento especializado &nbsp;·&nbsp; 100% remoto &nbsp;·&nbsp; Todo o Brasil
        </p>
      </div>
    </section>
  );
}